import { Ref } from 'vue-demi';
import { TranslateResult } from 'vue-i18n';

import { Ringtone } from '@/api';
import { IAgent, Contact, ISession, RuleGroup, IVoiceAPI, IVoiceEvents, AgentStatus } from '@/types';
import { ConferenceMember } from '../types';
import { AvatarOptions } from '@onereach/hitl-base-avatars';

export interface ICommonProps {
  isDebug?: boolean;
  /** Dialer store module will be initialized using this path */
  pathToStore?: string[];
  agentId: Ref<string>;
  avatar: Ref<AvatarOptions>;
  agents: Ref<IAgent[]>;
  statuses: Ref<AgentStatus[]>;
  ruleGroups: Ref<RuleGroup[]>;
  activeSessionId: Ref<string>;
  getAgentById: Ref<(agentId: string) => IAgent>;
  getContactById: Ref<(contactId: string) => Contact | undefined>;
  getContactByPhoneNumber: Ref<(number: string) => Contact | undefined>;
  getSessionById: Ref<(sessionId: string) => ISession>;
  Ringtone: typeof Ringtone;
  initializeVoiceAPI: (events: IVoiceEvents) => Promise<IVoiceAPI>;
  applyCommand: (payload: any) => Promise<void>;
  createEvent: (args: { sessionId: string; label: string; }) => Promise<void>;
  getConferenceMembers: (args: { sessionId: string; }) => Promise<{ data: ConferenceMember[]; }>;
  requestSessionById: (sessionId: string) => Promise<ISession | undefined>;
  goToSession: (args: { sessionId: string; }) => void;
  $t: (key: string, data?: object) => TranslateResult;
}

/** Common properties are saved in a static object to preserve references */
const common = {} as ICommonProps;
/** Call control object is global since simultaneous calls aren't allowed */
let VoiceAPI: IVoiceAPI;

/** Provide all external dependencies for Dialer module */
export function useCommonProps() {
  function provide(props: Partial<ICommonProps>) {
    Object.assign(common, props);
  }

  function debug(...args: any[]) {
    if (common.isDebug) {
      console.debug('[App Dialer]', ...args);
    }
  }

  const setVoiceAPI = (api: IVoiceAPI) => VoiceAPI = api;
  const getVoiceAPI = () => VoiceAPI;

  return Object.assign(common, { debug, provide, getVoiceAPI, setVoiceAPI });
}
